<template>
  <div
    style="width: 100%; font-size: 11px; margin-top: 2px "
    class="small-text"
  >
    <v-card>
      <v-simple-table
        dense
        class="font-size-11"
      >
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">
                Zone
              </th>
              <th class="text-left">
                Free
              </th>
              <th class="text-left">
                ATC
              </th>
              <th class="text-left">
                POB
              </th>
              <th class="text-left">
                OW
              </th>
              <th class="text-left">
                OB
              </th>
            </tr>
          </thead>
          <tbody>
            <template
              v-for="zone in zones"
            >
              <tr
                v-if="taxisForZone(zone.id).length > 0 || zone.id == (bookingForm && bookingForm.booking && bookingForm.booking.zone ? bookingForm.booking.zone.id : 0 )"
                :key="zone.id"
                :style="{ 'background': zone.id == (bookingForm && bookingForm.booking && bookingForm.booking.zone ? bookingForm.booking.zone.id : 0 ) ? '#00ff00' : 'white' }"
              >
                <td>
                  {{ zone != null ? zone.name : '' }}
                </td>
                <td>
                  {{ availableTaxis(zone.id) !=0 ? availableTaxis(zone.id) : ''  }}
                </td>
                <td>
                  {{ aboutToClearTaxis(zone.id) != 0 ? aboutToClearTaxis(zone.id) : '' }}
                </td>
                <td>
                  {{ pobTaxis(zone.id) != 0 ? pobTaxis(zone.id) : '' }}
                </td>
                <td>{{ owTaxis(zone.id) != 0 ? owTaxis(zone.id) : '' }}</td>
                <td>{{ onBreakTaxis(zone.id) != 0 ? onBreakTaxis(zone.id) : '' }}</td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </div>
</template>

<script>
import { Overwatch } from "@/components/util/Overwatch.js";

export default {
  name: "TaxiZonesSummary",
  components: {
  },
  model: {
    prop: "content",
    event: "input"
  },
  props: {
    taxis: Array,
    bookings: Array,
    zones: Array,
    bookingForm: Object
  },
  data() {
    return {
    };
  },
  computed: {
    
  },
  methods: {
    taxisForZone: function(id) {
      if (this.taxis == null) {
        return [];
      }

      var ow = new Overwatch(
        this.taxis,
        this.bookings,
        this.$store.state.use_zone_based_dispatch
      );

      return ow.sortTaxisByState(
        this.taxis.filter(function(t) {
          return t.zone == id;
        })
      );
    },
    availableTaxis: function(id) {

      var taxis = this.taxisForZone(id);

      return taxis.filter(function(t) {
          return t.state == 'available' || t.state == 'job_sent';
        }).length;
    },
    aboutToClearTaxis: function(id) {

      var taxis = this.taxisForZone(id);

      var ow = new Overwatch(
        this.taxis,
        this.bookings,
        this.$store.state.use_zone_based_dispatch
      );

       return taxis.filter(function(t) {
          return ow.categoryForTaxi(t) == "about_to_clear";
        }).length;
    },
    pobTaxis: function(id) {

       var taxis = this.taxisForZone(id);

      var ow = new Overwatch(
        this.taxis,
        this.bookings,
        this.$store.state.use_zone_based_dispatch
      );

      return taxis.filter(function(t) {
          return ow.categoryForTaxi(t) == "pob";
        }).length;
    },
    owTaxis: function(id) {

      var taxis = this.taxisForZone(id);

      var ow = new Overwatch(
        this.taxis,
        this.bookings,
        this.$store.state.use_zone_based_dispatch
      );

      return taxis.filter(function(t) {
        return t.state == 'on_job'
      }).length;
    },
    onBreakTaxis: function(id) {

      var taxis = this.taxisForZone(id);

      var ow = new Overwatch(
        this.taxis,
        this.bookings,
        this.$store.state.use_zone_based_dispatch
      );

      return taxis.filter(function(t) {
        return t.state == 'on_break'
      }).length;
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

table { border-collapse: collapse; }
tr { border: none; }

ul {
  list-style: none;
  padding-left: 0px;
}

.taxi-list-header {
  // color: green;
  font-weight: 800;
}

.small-text {
  font-size: 11px;
}
.font-size-11  td,th {
  font-size: 11px !important;
}
</style>
